module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('strong', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Illustrations#fm-1"
    }
  }, [_vm._v("List of illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Abbreviations#fm-2"
    }
  }, [_vm._v("List of abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#ch-1"
    }
  }, [_vm._v("1 "), _c('span', {
    staticClass: "sp"
  }, [_vm._v("Ways of reading Luke’s Gospel: through the Middle Ages")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#sec-1"
    }
  }, [_vm._v(" The early (and medieval) Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#sec-2"
    }
  }, [_vm._v(" From the early Church to the Middle Ages")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter01#sec-3"
    }
  }, [_vm._v(" Reflections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 "), _c('span', {
    staticClass: "sp"
  }, [_vm._v("Ways of reading Luke’s Gospel: from the Reformation to the present")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#sec-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The Reformation and post-Reformation Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#sec-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The modern and postmodern eras")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter02#sec-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Reflections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#ch-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 "), _c('span', {
    staticClass: "sp"
  }, [_vm._v("Reading Luke’s Gospel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Introducing Luke in the early Church")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Luke’s preface (Luke 1.1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter03#sec-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Reflections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 "), _c('span', {
    staticClass: "sp"
  }, [_vm._v("Mapping Luke’s Gospel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Luke and his world")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Geography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Spatial metaphors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter04#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Reflections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 "), _c('span', {
    staticClass: "sp"
  }, [_vm._v("The architecture of Luke’s Gospel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The anatomy of Luke’s narrative")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" The anatomy of Luke’s Gospel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter05#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Reflections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 "), _c('span', {
    staticClass: "sp"
  }, [_vm._v("‘I rejoice in God my saviour’: God, God’s purpose and Luke’s narrative")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" God saves: the God of Mary’s Song (Luke 1.46–55)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" God purposes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" God speaks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" God empowers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter06#sec-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Reflections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 "), _c('span', {
    staticClass: "sp"
  }, [_vm._v("‘I must preach the good news of God’s kingdom’: Jesus and his mission")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Mary’s Song and the politics of the kingdom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Jesus’ missional programme")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Jesus’ death and resurrection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter07#sec-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Reflections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 "), _c('span', {
    staticClass: "sp"
  }, [_vm._v("‘Take up their cross daily’: disciples and discipleship")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Mary, Mary’s Song and terms of allegiance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Faithful following")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter08#sec-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v(" Reflections")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm-t"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Bibliography#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Scripture_ack#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture acknowledgements")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4290e24c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0